import React, { useRef } from "react";
import PropTypes from "prop-types";

function AxisVertical({ yScale, ticks }) {
  const axisRef = useRef(null);
  return (
    <div className="tw-px-2 tw-opacity-80 tw-text-2xs tw-max-w-1/2">
      <div ref={axisRef} className="tw-opacity-0">
        {ticks.map((x) => (
          <div key={x}>{x}</div>
        ))}
      </div>
      {ticks.map((x) => (
        <div
          className="tw-absolute tw-right-1 transform-translate--y-50"
          style={{ top: yScale(x) }}
          key={x}
        >
          {x}
        </div>
      ))}
    </div>
  );
}

AxisVertical.propTypes = {
  yScale: PropTypes.func.isRequired,
  ticks: PropTypes.arrayOf(PropTypes.number).isRequired,
};

AxisVertical.defaultProps = {};

export default AxisVertical;
